<template>
  <div class="setting-main-container">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('customers.basic_info') }}</h3>
        </div>
        <div class="row">
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('customers.display_name') }}</label>
            <p v-if="viewCustomer && viewCustomer.name !=null">{{ viewCustomer.name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('customers.primary_contact_name') }}</label>
            <p v-if="viewCustomer && viewCustomer.contact_name !=null">{{ viewCustomer.contact_name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('customers.email') }}</label>
            <p v-if="viewCustomer && viewCustomer.email !=null">{{ viewCustomer.email }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('customers.phone') }}</label>
            <p v-if="viewCustomer && viewCustomer.phone !=null">{{ viewCustomer.phone }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('customers.primary_currency') }}</label>
            <p v-if="viewCustomer && viewCustomer.currency !=null">{{ viewCustomer.currency.code }}-{{ viewCustomer.currency.name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('customers.website') }}</label>
            <p v-if="viewCustomer && viewCustomer.website !=null">{{ viewCustomer.website }}</p>
          </div>
         

        </div>
      </div>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions,mapGetters } from 'vuex'
const { required, email, maxLength, numeric } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
        isLoading: false,
    }
  },
  computed: {
    ...mapGetters('customer', [
      'viewCustomer'
    ]),
  }, 
  created() {
  },
  validations: {},
  mounted () {},
  methods: {}
}
</script>
